import React from "react";
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from "../../../config/ui.js";
import PAGES from "../../data/PagesConstants.js";

const SupportPage = () => {
  return <Page
    uiPage={uiManager.getUiPage(PAGES.SupportPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Support"}]}
    className={'support-page'}
  >
    <PageContentWrapper contentHeading={"Support"}>
    </PageContentWrapper>
  </Page>
};

export default SupportPage;
